export const CloseIcon = ({
  onClick,
  className,
  color = "#848199",
}: {
  onClick?: React.MouseEventHandler<SVGSVGElement>;
  className?: string;
  color?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      viewBox="0 0 11 11"
      fill="none"
      style={{ cursor: "pointer" }}
      className={className}
      onClick={onClick}
      data-testid={"close-icon"}
    >
      <path d="M0.500488 0.5L10.4999 10.5" stroke={color} strokeWidth="1.00139" strokeLinecap="round" />
      <path d="M10.5005 0.5L0.501045 10.5" stroke={color} strokeWidth="1.00139" strokeLinecap="round" />
    </svg>
  );
};
